// Auth route — `/auth/resend-verification` (Wave D4).
//
// Standalone landing for re-sending the email-verification link. The
// existing `/auth/verify-pending` route already exposes a "Resend" button,
// but PROJECT-STATE.md flagged a missing dedicated entry-point so deep
// links from emails / external nudges have a stable target. The page
// reuses `<VerifyPendingPage>` so copy + cooldown logic stay in one
// place; the route just wires the component into the router with an
// optional `email` search param (mirrors `/auth/verify-pending`).

import { createRoute } from '@tanstack/react-router';

import { VerifyPendingPage } from '@/features/auth/VerifyPendingPage';

import { Route as RootRoute } from '../__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/auth/resend-verification',
  validateSearch: (search): { email?: string } => ({
    email: typeof search.email === 'string' ? search.email : undefined,
  }),
  component: VerifyPendingPage,
});
